import iamotaAjax from 'scripts/helpers/iamota-ajax';
var sectionRendering = {
  /**
   * Fetches multiple sections based on the provided section IDs and optional page URL.
   * @param {Array|string} sections - The section IDs to fetch.
   * @param {string} [pageUrl=window.location.pathname] - The page URL for the request.
   * @returns {Promise} - The result of the AJAX get request.
   */
  fetch: function fetch(sections) {
    var pageUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.pathname;
    var sectionsArray = Array.isArray(sections) ? sections : [sections];
    var queryData = new URLSearchParams();
    sectionsArray.forEach(id => queryData.append('sections[]', id));
    return iamotaAjax.get(pageUrl, {
      before: sectionsArray.map(section_id => "Shopify:sectionRendering:".concat(section_id, ":fetching")).concat('Shopify:sectionRendering:fetching'),
      success: sectionsArray.map(section_id => "Shopify:sectionRendering:".concat(section_id, ":fetched")).concat('Shopify:sectionRendering:fetched'),
      error: sectionsArray.map(section_id => "Shopify:sectionRendering:".concat(section_id, ":error")).concat('Shopify:sectionRendering:error')
    }, queryData, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      }
    }).then(sections => {
      if (typeof sections === 'string') {
        throw new Error('Entire page returned instead of a section.');
      }
      if (typeof sections !== 'object' || sections === null || Array.isArray(sections)) {
        throw new Error('Expected a JSON object but received something else.');
      }
      var missingSections = sectionsArray.filter(section_id => !(section_id in sections));
      if (missingSections.length > 0) {
        throw new Error("Missing sections for IDs: ".concat(missingSections.join(', ')));
      }
      return sections;
    });
  },
  /**
   * Fetches a single section based on the provided section ID and optional page URL.
   * @param {string} section_id - The section ID to fetch.
   * @param {string} [pageUrl=window.location.pathname] - The page URL for the request.
   * @returns {Promise} - The result of the AJAX get request.
   */
  fetchSingle: function fetchSingle(section_id) {
    var pageUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.pathname;
    var queryData = {
      section_id
    };
    return iamotaAjax.get(pageUrl, {
      before: ["Shopify:sectionRendering:".concat(section_id, ":fetching"), 'Shopify:sectionRendering:fetchingSingle'],
      success: ["Shopify:sectionRendering:".concat(section_id, ":fetched"), 'Shopify:sectionRendering:fetchedSingle'],
      error: ["Shopify:sectionRendering:".concat(section_id, ":error"), 'Shopify:sectionRendering:error']
    }, queryData, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/html'
      }
    }).then(sectionContent => {
      if (sectionContent.includes('<html') || sectionContent.includes('<head') || sectionContent.includes('<body')) {
        throw new Error('Entire page returned instead of a section.');
      }
      return sectionContent;
    });
  }
};
export default sectionRendering;